const searchIcon = document.querySelector(
  ".t4s-site-nav__search .t4s-pr.search-trigger"
);

const searchInput = document.querySelector('header [name="q"]');
searchIcon &&
  searchIcon.addEventListener("click", () => {
    searchInput && searchInput.click();
  });
searchInput &&
  searchInput.addEventListener("click", () => {
    setTimeout(() => {
      let autoCompleteWrapper = document.querySelector(
        ".wizzy-autocomplete-wrapper"
      );

      autoCompleteWrapper &&
        autoCompleteWrapper.addEventListener("click", () => {
          autoCompleteWrapper.style.display = "none";
        });
    }, 100);
  });
window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: 5000,
        mobile: 3000,
      };
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      products.forEach((product) => {
        if (product.mainImage == "https://via.placeholder.com/360x360") {
          product.mainImage =
            "//little-tags-luxury.myshopify.com/cdn/shop/files/dummy-product_1.png?v=1745666547";
        }
      });
      return products;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      /*code to close searchbar pannel*/
      let closeBtn = document.querySelector(
        "#shopify-section-header-e-commerce #searchContainer .search-close"
      );
      if (closeBtn) {
        closeBtn.click();
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      if (!payload.response.payload.hasExactMatch) {
        // payload.error = true;
      }
      return payload;
    }
  );
};
